'use strict';

import request from 'superagent';
import api from './core';
import moment from 'moment';

export async function emptySheet(company) {
    return {
        id: undefined,
        interests: (await contracts(company)).results.map((c) => ({
            contract: c,
            pu: 0,
            pp: 0,
            reprise: 0
        })),
        company,
        date: moment().format('Y-MM-DD'),
        reference: ''
    };
}

export function contracts(company) {
    return api.forwardResult(
        api.prepare(request.get(api.url(`/sheets/contracts/`))).query({company}),
        'results'
    );
}

export function create(sheet) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/sheets/'))).send(sheet),
        'id'
    );
}

export function update(sheet) {
    const id = encodeURIComponent(sheet.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/sheets/${id}/`))).send(sheet),
        'id'
    );
}

export function fetch(id) {
    return api.forwardResult(api.prepare(request.get(api.url(`/sheets/${id}/`))), 'id');
}

export function list(args) {
    return api.forwardResult(
        api.prepare(request.get(api.url('/sheets/')).query(args)),
        'results'
    );
}

export function freeze(args) {
    return api.forwardResult(
        api.prepare(request.get(api.url('/sheets/freeze/')).query(args)),
        'ok'
    );
}

export function exprt(args) {
    return api.forwardResult(
        api.prepare(request.get(api.url('/sheets/export/')).query(args)),
        'url'
    );
}



// WEBPACK FOOTER //
// ./src/api/sheets.js